import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { secureBaseQuery } from "./secureBaseQuery";
import {dynamicBaseQuery} from "./dynamicBaseQuery.js";
import { api } from "../../Appjs/api.js";
export const clickerApi = createApi({
  reducerPath: "clickerApi",
  baseQuery: fetchBaseQuery({
    baseUrl: api,
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem("accessToken");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  // baseQuery: dynamicBaseQuery,
  tagTypes: ["Clicker"],
  endpoints: (builder) => ({
    createClicker: builder.mutation({
      query: (data) => ({
        url: `/clicker/create-clicker`,
        method: "POST",
        body: data, // send as JSON in request body
        headers: {
          "Content-Type": "application/json", // explicitly set JSON
        },
      }),
      invalidatesTags: ["Clicker"],
    }),

    // getAllClickerCampaign: builder.query({
    //   query: () => ({
    //     url: "/clicker/get-all-clicker-campaign",
    //     method: "GET",
    //   }),
    //   providesTags: ["Clicker"],
    // }),
    getAllClickerCampaign: builder.query({
      query: ({ from, to, type } = {}) => {
        const params = new URLSearchParams();
        if (from) params.append("from", from);
        if (to) params.append("to", to);
        if (type) params.append("type", type);

        return {
          url: `/clicker/get-all-clicker-campaign?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: ["Clicker"],
    }),
    getClickerUploadSummary: builder.query({
      query: ({ startdate, enddate, file_status, page = 1, limit = 25 }) => {
        const params = new URLSearchParams();
        if (startdate) params.append("startdate", startdate);
        if (enddate) params.append("enddate", enddate);
        if (file_status) params.append("file_status", file_status);
        params.append("page", page);
        params.append("limit", limit);

        return `/clickerReport/get-clickerupload-data?${params.toString()}`;
      },
    }),
    // In your reportApi.js file, add this endpoint
    getClickerNumbersByCampaign: builder.query({
      query: ({ clicker_campaign_id, page, status }) => {
        const params = new URLSearchParams();
        params.append("clicker_campaign_id", clicker_campaign_id);
        params.append("page", page);

        if (status) params.append("stat", status); // ✅ IMPORTANT

        return `/clickerReport/get-clickerNumber?${params.toString()}`;
      },

      // 🔥 cache busting
      serializeQueryArgs: ({ endpointName, queryArgs }) =>
        `${endpointName}-${queryArgs.clicker_campaign_id}-${queryArgs.page}-${queryArgs.status || "ALL"}`,
    }),

    getClickerStatusCount: builder.query({
      query: ({ startdate, enddate, file_status = "" }) =>
        `/clickerReport/get-clicker-summary?startdate=${startdate}&enddate=${enddate}&file_status=${file_status}`,
    }),
    // Add this mutation for downloading clicker CSV
    downloadClickerCampaignCSV: builder.mutation({
      query: ({ clicker_campaign_id, status }) => {
        const params = new URLSearchParams();
        params.append("clicker_campaign_id", clicker_campaign_id);
        if (status) params.append("status", status);

        return {
          url: `/clickerReport/download/clickerData_by_campaign?${params.toString()}`,
          method: "GET",
          responseHandler: async (response) => {
            const blob = await response.blob();
            return blob;
          },
          cache: "no-cache",
        };
      },
    }),

    getscheduledata: builder.query({
      query: () => ({
        url: "/clicker/get-all-schedule-campaign",
        method: "GET",
      }),
      providesTags: ["Clicker"],
    }),
    getclickerbyid: builder.query({
      query: (id) => ({
        url: `/clicker/get-schedule-campaignbyId/${id}`,
        method: "GET",
      }),
      providesTags: ["Clicker"],
    }),
    deleteRowData: builder.mutation({
      query: (id) => ({
        url: `/clicker/delete-clicker-data/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Clicker"],
    }),
    updateClicker: builder.mutation({
      query: ({ id, body }) => ({
        url: `/clicker/update-clicker/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Clicker"],
    }),
    getClickerPreview: builder.mutation({
      query: (formData) => ({
        url: "/clicker/clicker-file/counts",
        body: formData,
        method: "POST",
      }),
    }),
    getClickerCountNumber: builder.query({
      query: ({ clicker_campaign_id, page, limit, type }) => ({
        url: `/clickerReport/get-clickerCount?clicker_campaign_id=${clicker_campaign_id}&page=${page}&limit=${limit}&type=${type}`,
      }),
    }),
    getActualCount: builder.query({
      query: ({ clicker_campaign_id, page }) => ({
        url: `/clickerReport/get-clickerActualCount?clicker_campaign_id=${clicker_campaign_id}&page=${page}`,
      }),
    }),
    getclickercountdetail: builder.query({
      query: ({ short_code, type }) => {
        const params = new URLSearchParams();
        if (type) params.append("type", type);

        return {
          url: `/clicker/clicker-report/${short_code}?${params.toString()}`,
        };
      },
    }),
    clickerConsolidatedReport: builder.query({
      query: ({ startdate, enddate }) => ({
        url: `/report/get-clicker-consolidated-report?startdate=${startdate}&enddate=${enddate}`,
      }),
    }),

    downloadClickerReport: builder.mutation({
      query: ({ shortcode, type }) => ({
        url: `/clicker/download-clicker-report/${shortcode}?type=${type}`,
        method: "GET",
        responseHandler: async (response) => {
          const blob = await response.blob();
          return blob;
        },
        cache: "no-cache",
      }),
    }),
    downloadClickerReportByDate: builder.mutation({
      query: ({ startdate, enddate, type }) => ({
        url: `/clicker/download-clicker-report-by-date?startdate=${startdate}&enddate=${enddate}&type=${type}`,
        method: "GET",
        responseHandler: async (response) => {
          const blob = await response.blob();
          return blob;
        },
        cache: "no-cache",
      }),
    }),
    downloadCampaignReportByDate: builder.mutation({
      query: ({ startdate, enddate, type }) => ({
        url: `/clicker/download-campaign-report-by-date?startdate=${startdate}&enddate=${enddate}&type=${type}`,
        method: "GET",

        responseHandler: async (response) => {
          const blob = await response.blob();
          return blob;
        },

        cache: "no-cache",
      }),
    }),

    downloadClickerCountReport: builder.mutation({
      query: ({ clicker_campaign_id, stat, type }) => ({
        url: `/clicker/download-clickerCount?clicker_campaign_id=${clicker_campaign_id}&stat=${stat || ""}&type=${type || ""}`,
        method: "GET",
        responseHandler: async (response) => await response.blob(),
      }),
    }),
    downloadClicksReportByDate: builder.mutation({
      query: ({ start_date, end_date, type = "all" }) => {
        let url = `/clicker/download-clicks-report-by-date?start_date=${start_date}&end_date=${end_date}&type=${type}`;

        return {
          url,
          method: "GET",
          responseHandler: async (response) => {
            const contentType = response.headers.get("content-type");

            if (contentType && contentType.includes("application/json")) {
              return await response.json();
            }

            return await response.blob();
          },
        };
      },
    }),
    downloadActualClicksReportByDate: builder.mutation({
      query: ({ start_date, end_date }) => {
        const url = `/clicker/download-actual-clicks-report-by-date?start_date=${start_date}&end_date=${end_date}`;

        return {
          url,
          method: "GET",
          responseHandler: async (response) => {
            const contentType = response.headers.get("content-type");

            if (contentType && contentType.includes("application/json")) {
              return await response.json();
            }

            return await response.blob();
          },
        };
      },
    }),
    getClickerClickList: builder.query({
      query: ({ clicker_campaign_id, type = "all", page = 1, limit = 25 }) => ({
        url: `/clicker/get-clicker-click-list?clicker_campaign_id=${clicker_campaign_id}&type=${type}&page=${page}&limit=${limit}`,
        method: "GET",
      }),
    }),

    downloadClickerClickList: builder.mutation({
      query: ({ clicker_campaign_id, type = "all", from, to, stat }) => {
        const params = new URLSearchParams();

        if (clicker_campaign_id) {
          params.append("clicker_campaign_id", clicker_campaign_id);
        }

        if (type) params.append("type", type);
        if (from) params.append("from", from);
        if (to) params.append("to", to);
        if (stat) params.append("stat", stat);

        return {
          url: `/clicker/download-clicker-click-list?${params.toString()}`,
          method: "GET",
          responseHandler: async (response) => {
            const contentType = response.headers.get("content-type");

            if (contentType && contentType.includes("application/json")) {
              return await response.json();
            }

            return await response.blob();
          },
          cache: "no-cache",
        };
      },
    }),
    deleteDownloadRequest: builder.mutation({
      query: (dlr_request_id) => ({
        url: `/clicker/delete-download-request/${dlr_request_id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Clicker"],
    }),
  }),
});

export const {
  useCreateClickerMutation,
  useGetActualCountQuery,
  useGetClickerCountNumberQuery,
  useGetclickerbyidQuery,
  useGetAllClickerCampaignQuery,
  useGetscheduledataQuery,
  useDeleteRowDataMutation,
  useUpdateClickerMutation,
  useGetClickerUploadSummaryQuery,
  useGetClickerNumbersByCampaignQuery,
  useDownloadClickerCampaignCSVMutation,
  useGetClickerPreviewMutation,
  useGetclickercountdetailQuery,
  useClickerConsolidatedReportQuery,
  useDownloadClickerReportMutation,
  useDownloadClickerReportByDateMutation,
  useGetClickerStatusCountQuery,
  useDownloadCampaignReportByDateMutation,
  useDownloadClickerCountReportMutation,
  useDownloadClicksReportByDateMutation,
  useDownloadActualClicksReportByDateMutation,
  useGetClickerClickListQuery,
  useDownloadClickerClickListMutation,
  useDeleteDownloadRequestMutation,
} = clickerApi;
